export default __webpack_public_path__ + "static/media/school-feeding-program.0751c828.jpg";